/* eslint-disable indent */
import l10n from './reactPPl10nHelper';

const paypalForm = l10n.getContent('smarthelp/paypalmeForm.paypalform');

// <------------- Dynamic loading fields --------------->
const selectViolationPartial = () => ({
  id: 'select_violation_type_partial',
  ref_id: 'select_violation_type_all',
  required: true,
  type: 'select',
  options: [
    paypalForm('selection.default'),
    paypalForm('selection.L2.options.mature'),
    paypalForm('selection.L2.options.child'),
    paypalForm('selection.L2.options.intolerance'),
  ],
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm('selection.L1.options.offensive')],
});

const selectViolationTypeAll = () => ({
  id: 'select_violation_type_all',
  required: true,
  type: 'select',
  options: [
    paypalForm('selection.default'),
    paypalForm('selection.L2.options.mature'),
    paypalForm('selection.L2.options.child'),
    paypalForm('selection.L2.options.intolerance'),
    paypalForm('selection.L2.options.counterfeit'),
    paypalForm('selection.L2.options.firearms'),
    paypalForm('selection.L2.options.gambling'),
    paypalForm('selection.L2.options.marketing'),
    paypalForm('selection.L2.options.drugs'),
    paypalForm('selection.L2.options.illegal'),
    paypalForm('selection.L2.options.copyright'),
  ],
  depends_on_id: 'select_violation',
  depends_on_value: [
    paypalForm('selection.L1.options.paypalme'),
    paypalForm('selection.L1.options.moneyPool'),
    paypalForm('selection.L1.options.others')],
});

const textPayPalMeLink = () => ({
  id: 'paypalme_link',
  type: 'text',
  default_text: paypalForm('selection.textField.paypalme'),
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm('selection.L1.options.paypalme')],
  url_validation: 'www.paypal.me',
});

const textMoneyPoolLink = () => ({
  id: 'money_pool_link',
  type: 'text',
  default_text: paypalForm('selection.textField.moneyPool'),
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm('selection.L1.options.moneyPool')],
  url_validation: 'www.paypal.com/pools',
});

const textTransactionId = () => ({
  id: 'trans_id',
  type: 'text',
  default_text: paypalForm('selection.textField.transaction'),
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm('selection.L1.options.offensive')],
});

const textTransactionIdOrEmail = () => ({
  id: 'trans_id_or_email',
  type: 'text',
  default_text: paypalForm('selection.textField.transactionEmail'),
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm('selection.L1.options.others')],
});
// <------------- End: Dynamic loading fields --------------->

// Parse Email for for the AUP PayPal.Me webform
const parseEmailForm = () => [{
  default_text: `
    <b>${paypalForm('violdation.header')}</b><br>
    <br>${paypalForm('violdation.announcement')}<br>
    <br><b>${paypalForm('report.header')}</b><br>
    <br>${paypalForm('report.body')}<br>
    <br>${paypalForm('report.continue')}<br>
    <br><b>${paypalForm('report.nextHeader')}</b><br>
    <br>${paypalForm('report.contentReview')}<br>
    <br>${paypalForm('report.contentDetail')}<br>
    <br><b>${paypalForm('selection.header')}</b><br>
    <br>${paypalForm('selection.L1.placeHolder')}`,
  required: false,
  type: 'paragraph',
}, {
  id: 'select_violation',
  required: true,
  type: 'select',
  options: [
    paypalForm('selection.default'),
    paypalForm('selection.L1.options.paypalme'),
    paypalForm('selection.L1.options.moneyPool'),
    paypalForm('selection.L1.options.offensive'),
    paypalForm('selection.L1.options.others'),
  ],
},
  selectViolationPartial(),
  selectViolationTypeAll(),
  textPayPalMeLink(),
  textMoneyPoolLink(),
  textTransactionId(),
  textTransactionIdOrEmail(),
{
  id: 'additional_comments',
  required: true,
  type: 'textarea',
  default_text: paypalForm('textField.additional'),
  character_limit: '2500',
}, {
  id: 'first_name',
  type: 'text',
  default_text: paypalForm('textField.firstName'),
  required: true,
  character_limit: '200',
},
{
  id: 'last_name',
  type: 'text',
  default_text: paypalForm('textField.lastName'),
  required: true,
  character_limit: '200',
},
{
  id: 'email_address',
  type: 'text',
  default_text: paypalForm('textField.email'),
  required: true,
  character_limit: '200',
}];

const topicTcodeMapping = (fieldName) => {
  switch (fieldName) {
    case paypalForm('selection.L2.options.child'):
      return 'AUPACE001';
    case paypalForm('selection.L2.options.intolerance'):
      return 'AUPOFF001';
    case paypalForm('selection.L2.options.firearms'):
    case paypalForm('selection.L2.options.marketing'):
    case paypalForm('selection.L2.options.illegal'):
      return 'AUPREP001';
    case paypalForm('selection.L2.options.mature'):
    case paypalForm('selection.L2.options.counterfeit'):
    case paypalForm('selection.L2.options.gambling'):
    case paypalForm('selection.L2.options.copyright'):
    case paypalForm('selection.L2.options.drugs'):
      return 'AUPLEGAL001';
    default:
      return 'PAYPALME001';
  }
};

module.exports = {
  parseEmailForm,
  selectViolationPartial,
  selectViolationTypeAll,
  textPayPalMeLink,
  textMoneyPoolLink,
  textTransactionId,
  textTransactionIdOrEmail,
  topicTcodeMapping,
};
